var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialNetworkIconEmail = function SvgSocialNetworkIconEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 25 16.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4,11.2L0.3,2.7C0.2,2.6,0,2.7,0,2.9v13.2c0,0.1,0.1,0.2,0.2,0.2h24.6c0.1,0,0.2-0.1,0.2-0.2V2.9c0-0.2-0.2-0.3-0.3-0.2l-12,8.5C12.6,11.2,12.5,11.2,12.4,11.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4,8.7L0.5,0.4C0.4,0.3,0.4,0,0.6,0h23.7c0.2,0,0.3,0.2,0.1,0.4L12.6,8.7C12.6,8.8,12.5,8.8,12.4,8.7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialNetworkIconEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "adafa4c02efb33341e4b74b1a477d75d.svg";